<ng-container *ngIf="wizardOptions$ | async as meeting">
    <p *ngIf="meeting.meetingTime; else showActiveMeetingInstructions">
        Your "{{ meeting?.subject }}" meeting is currently scheduled for
        <strong
            >{{ scheduledTime.start | date: 'fullDate' }} from {{ scheduledTime.start | date: 'h:mm a' }} to
            {{ scheduledTime.end | date: 'h:mm a' }}.</strong
        >
        <ng-container *ngIf="data?.mode === 'group-class'">
            Reschedule to a specific date and time, indicated below:</ng-container
        ><ng-template> To reschedule select an option below and click “Next”. </ng-template>
    </p>
    <ng-template #showActiveMeetingInstructions>
        <p>
            Your "{{ meeting?.subject }}" meeting is not yet scheduled. To reschedule this request select an option
            below and click “Next”.
        </p>
    </ng-template>
    <div class="reschedule__options" *ngIf="data?.mode !== 'group-class'">
        <div class="ui radio checkbox">
            <input
                type="radio"
                name="reschedule"
                [checked]="selectedPicker === 'range'"
                (click)="handleSelect('range')"
            />
            <label *ngIf="isGroupMeeting"
                >Ask my invitees to suggest a new date and time, based on the time frame below</label
            >
            <label *ngIf="!isGroupMeeting"
                >Ask my invitee to select a new date and time, based on the time frame below</label
            >
        </div>
        <div class="ui radio checkbox">
            <input
                type="radio"
                name="reschedule"
                [checked]="selectedPicker === 'specific'"
                (click)="handleSelect('specific')"
            />
            <label>Reschedule to a specific date and time, indicated below</label>
        </div>
    </div>
</ng-container>
